import { apiFetch, getApiUrl } from '@/lib/api';

const API_URL = getApiUrl();
export async function actionGetCoaches(): Promise<any> {
  const response = await apiFetch(`/users/coaches`);
  if (!response.ok) {
    console.error(`Failed to get coaches for customer.`);
    return { error: `Falha ao carregar os treinadores.` };
  }

  const body = await response.json();
  const coaches = body.map((item: any) => {
    const photoUrl = item.photo
      ? new URL(item.photo, API_URL).toString()
      : null;
    return {
      ...item,
      photo: photoUrl,
    };
  });

  // Return the fetched plan
  return {
    success: true,
    data: coaches,
  };
}

export async function actionGetCoacheById(id: string): Promise<any> {
  const response = await actionGetCoaches();
  if (!response.success) {
    console.error(`Failed to get coach.`);
    return { error: `Falha ao carregar o treinador` };
  }

  const coach = response.data.find((item: any) => item.id === Number(id));

  // Return the fetched plan
  return {
    success: true,
    data: coach,
  };
}
